 export enum DsnNatureDeclaration {
MENSUELLE = 1,
FINCONTRAT = 2,
ARRET = 4,
REPRISE = 5,
OETH = 6,
FINCONTRATUNIQUE = 7,
AMORCAGETAUXPAS = 8,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration.ts